app.component('outputScore', {
    templateUrl: 'app/common/component/outputscore/output_score.html',
    bindings: {
        scoreMessage : '@',
        scoreValue : '<',
        scoreDate : '<'
    }
});
